<template>
    <div>
        <banet-modal-confirm
                @confirmNo="confirmDelete(false)"
                @confirmYes="confirmDelete(true)"
                :show="showConfirmDelete"
                :showFooter="true"
                :title="getTranslation('modal_confirm_title')"
                :body="getTranslation('label_confirm_client_file_delete')">
        </banet-modal-confirm>
        <div class="row">
            <call-settings :client="client"></call-settings>
        </div>
        <div class="row">
            <div class="row" v-if="!hideTitle">
                <div class="col-md-12">
                    <h2>{{ getTranslation('lbl_client_edit_headline') }} </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <form @submit.prevent="save">
                        <div class="form-group">
                            <label for="clientName">{{ getTranslation('lbl_client_name') }} *</label>
                            <input
                                    type="text"
                                    id="clientName"
                                    class="form-control"
                                    formControlName="clientName"
                                    v-model="client.clientName">
                        </div>
                        <div class="form-group">
                            <label for="firstName">{{ getTranslation('lbl_user_first_name') }} *</label>
                            <input
                                    type="text"
                                    id="firstName"
                                    class="form-control"
                                    formControlName="firstName"
                                    v-model="client.user.firstName">
                        </div>
                        <div class="form-group">
                            <label for="lastName">{{ getTranslation('lbl_user_last_name') }}</label>
                            <input
                                    type="text"
                                    id="lastName"
                                    class="form-control"
                                    formControlName="lastName"
                                    v-model="client.user.lastName">
                        </div>
                        <div class="form-group">
                            <label for="email">{{ getTranslation('lbl_user_mail') }} *</label>
                            <input
                                    type="email"
                                    id="email"
                                    class="form-control"
                                    formControlName="email"
                                    v-model="client.user.email"
                            >
                        </div>
                        <div class="form-group">
                            <label for="username">{{ getTranslation('lbl_client_username') }} *</label>
                            <input
                                    type="text"
                                    id="username"
                                    class="form-control"
                                    formControlName="username"
                                    v-model="client.username">
                        </div>
                        <div class="form-group">
                            <label for="hotline-number">{{ getTranslation('lbl_client_hotlineNumber') }}</label>
                            <input
                                    type="text"
                                    id="hotline-number"
                                    class="form-control"
                                    formControlName="hotline-number"
                                    v-model="hotlineNumber"
                                    @keyup="validatePhoneNum($event)"
                            >
                        </div>
                        <!--<div class="form-group">-->
                        <!--<label for="password">Password</label>-->
                        <!--<input-->
                        <!--type="password"-->
                        <!--id="password"-->
                        <!--class="form-control"-->
                        <!--formControlName="password"-->
                        <!--autocomplete="new-password"-->
                        <!--v-model="client.password" >-->
                        <!--</div>-->
                        <div class="form-group">
                            <label for="twilioAccountSid">{{ getTranslation('lbl_client_twilioAccountSid') }}</label>
                            <input
                                    type="text"
                                    id="twilioAccountSid"
                                    class="form-control"
                                    formControlName="twilioAccountSid"
                                    v-model="client.twilioAccountSid">
                        </div>
                        <div class="form-group">
                            <label for="twilioAccountToken">{{ getTranslation('lbl_client_twilioAccountToken') }}</label>
                            <input
                                    type="text"
                                    id="twilioAccountToken"
                                    class="form-control"
                                    formControlName="twilioAccountToken"
                                    v-model="client.twilioAccountToken">
                        </div>
                        <div class="form-group">
                            <label>{{ getTranslation('lbl_client_clientApiToken') }}</label>
                            <button v-if="client.clientApiToken"
                                    class="btn btn-default" v-clipboard:copy="client.clientApiToken" @click.prevent="">
                                {{ getTranslation('lbl_copy') }}
                            </button>
                            <span v-if="!client.clientApiToken">{{ getTranslation('lbl_none_set') }}</span>
                            <!--<input-->
                            <!--type="text"-->
                            <!--id="clientApiToken"-->
                            <!--class="form-control"-->
                            <!--formControlName="clientApiToken"-->
                            <!--v-model="client.clientApiToken">-->
                        </div>
                        <div class="form-group">
                            <label for="langSelector">{{ getTranslation('lbl_language') }}</label>
                            <div class="dropdown" v-on-clickaway="dropClose" :class="{ open: isOpened }"
                                 id="langSelector">
                                <button class="dropdown-toggle form-control" @click.prevent="dropToggle" type="button" >
                                    {{ getTranslation(labelLangString) }}
                                    <span class="caret"></span></a>
                                </button>
                                <ul class="dropdown-menu" @click="dropToggle">
                                    <li><a href="#" @click.prevent="setClientLanguage('de');">{{
                                        getTranslation('lbl_deutsch') }}</a></li>
                                    <li><a href="#" @click.prevent="setClientLanguage('en');">{{
                                        getTranslation('lbl_english') }}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-group same-row-spaced-apart-aligned" style="margin: 2.5rem 0;">
                          <label style="margin-bottom: 0 !important;">{{ getTranslation('lbl_activate_customers') }}</label>
                          <app-switch
                              :autoSave="true"
                              :isInList="false"
                              identification="useCustomers"
                              v-model="useCustomers"
                          />
                        </div>
                        <div class="form-group">
                            <label>{{ getTranslation('lbl_upload_files') }}</label>
                            <banet-upload class="well" :autoUpload="true" @setFiles="setFiles" @tempFiles="setTempFiles"
                                          ref="banetUpload" v-if="showUploadForm"></banet-upload>
                        </div>
                        <div class="well" v-if="audioDisplay">
                            <div class="row">
                                <div class="col-sm-12" style="padding-right: 10px;">
                                    <router-link :to="`/history/files/${$route.params.id}`" activeClass="active" tag="button"
                                                 class="btn btn-primary pull-right"
                                                 :title="getTranslation('lbl_history_sounds')">
                                        <i class="fa fa-history" aria-hidden="true"></i>
                                    </router-link>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 15px;">
                                <label class="col-md-4">{{ getTranslation('lbl_client_onDutyFile') }}</label>
                                <div class="col-md-8" v-if="client.onDutyFile">
                                    <div class="col-sm-8">
                                        {{ client.onDutyFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview0')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview0'))" >
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview0')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_onDutyFile" ref="audioPreview0"
                                                   @ended="stopRecord('audioPreview0')"
                                                   :src="filePath + 'getondutyfile' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('onDutyFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-md-4">{{ getTranslation('lbl_client_offDutyFile') }}</label>
                                <div class="col-md-8" v-if="client.offDutyFile">
                                    <div class="col-sm-8">
                                        {{ client.offDutyFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview1')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview1'))">
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview1')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_offDutyFile" ref="audioPreview1"
                                                   @ended="stopRecord('audioPreview1')"
                                                   :src="filePath + 'getoffdutyfile' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('offDutyFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!--<input
                                        type="file"
                                        id="offDutyFile"
                                        class="form-control"
                                        formControlName="offDutyFile"
                                        @change="setFile('offDutyFile', $event)"
                                >-->
                            </div>
                            <div class="row">
                                <label class="col-md-4">{{ getTranslation('lbl_client_disturbFile') }}</label>
                                <div class="col-md-8" v-if="client.disturbFile">
                                    <div class="col-sm-8">
                                        {{ client.disturbFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview2')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview2'))">
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview2')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_disturbFile" ref="audioPreview2"
                                                   @ended="stopRecord('audioPreview2')"
                                                   :src="filePath + 'disturb' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('disturbFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true" :title="getTranslation('lbl_delete')"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!--<input
                                        type="file"
                                        id="disturbFile"
                                        class="form-control"
                                        formControlName="disturbFile"
                                        @change="setFile('disturbFile', $event)"
                                >-->
                            </div>
                            <div class="row">
                                <label class="col-md-4">{{ getTranslation('lbl_client_helpFile') }}</label>
                                <div class="col-md-8" v-if="client.helpFile">
                                    <div class="col-sm-8">
                                        {{ client.helpFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview3')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview3'))">
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview3')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_helpFile" ref="audioPreview3"
                                                   @ended="stopRecord('audioPreview3')"
                                                   :src="filePath + 'helptext' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('helpFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!--<input
                                        type="file"
                                        id="helpFile"
                                        class="form-control"
                                        formControlName="helpFile"
                                        @change="setFile('helpFile', $event)"
                                >-->
                            </div>
                            <div class="row">
                                <label class="col-md-4">{{ getTranslation('lbl_client_acceptedFile') }}</label>
                                <div class="col-md-8" v-if="client.acceptedFile">
                                    <div class="col-sm-8">
                                        {{ client.acceptedFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview4')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview4'))">
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview4')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_acceptedFile" ref="audioPreview4"
                                                   @ended="stopRecord('audioPreview4')"
                                                   :src="filePath + 'accepted' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('acceptedFile')" class="btn btn-danger" :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!--<input
                                        type="file"
                                        id="acceptedFile"
                                        class="form-control"
                                        formControlName="acceptedFile"
                                        @change="setFile('acceptedFile', $event)"
                                >-->
                            </div>
                            <div class="row">
                                <label class="col-md-4">{{ getTranslation('lbl_client_deniedFile') }}</label>
                                <div class="col-md-8" v-if="client.deniedFile">
                                    <div class="col-sm-8">
                                        {{ client.deniedFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview5')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview5'))">
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview5')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_deniedFile" ref="audioPreview5"
                                                   @ended="stopRecord('audioPreview5')"
                                                   :src="filePath + 'denied' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('deniedFile')" class="btn btn-danger"
                                                    :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!--<input
                                        type="file"
                                        id="deniedFile"
                                        class="form-control"
                                        formControlName="deniedFile"
                                        @change="setFile('deniedFile', $event)"
                                >-->
                            </div>
                            <div class="row">
                                <label class="col-md-4">{{ getTranslation('lbl_client_invalidFile') }}</label>
                                <div class="col-md-8" v-if="client.invalidFile">
                                    <div class="col-sm-8">
                                        {{ client.invalidFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview6')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview6'))">
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview6')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_invalidFile" ref="audioPreview6"
                                                   @ended="stopRecord('audioPreview6')"
                                                   :src="filePath + 'invalid' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('invalidFile')" class="btn btn-danger"
                                                    :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-bottom: 15px;">
                                <label class="col-md-4">{{ getTranslation('lbl_client_inputCode') }}</label>
                                <div class="col-md-8" v-if="client.codeFile">
                                    <div class="col-sm-8">
                                        {{ client.codeFile }}
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="pull-right">
                                            <button @click.prevent="playRecord('audioPreview7')" class="btn btn-default"
                                                    :title="getTranslation(playStopTooltip('audioPreview7'))">
                                            <span class="fa"
                                                  :class="audioPreviewClass('audioPreview7')"
                                                  aria-hidden="true"></span>
                                            </button>
                                            <audio id="audio_codeFile" ref="audioPreview7"
                                                   @ended="stopRecord('audioPreview7')"
                                                   :src="filePath + 'code' + fileLinkVar">
                                            </audio>
                                            <button @click.prevent="showConfirmDialog('codeFile')" class="btn btn-danger"
                                                    :title="getTranslation('lbl_delete')">
                                                <span class="fa fa-trash" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="divider"></div>
                        <button class="btn btn-primary" type="submit">
                            {{ translations.lbl_save }}
                        </button>
                        <button class="btn pull-right" type="button" @click.prevent="goBack()">
                            {{ translations.app_lbl_action_cancel }}
                        </button>
                    </form>
                </div>

                <div class="col-md-6">
                    <div class="well">
                        <h2>{{ getTranslation('headline_change_password') }}</h2>
                        <form name="chnPsw" @submit.prevent="changePsw">
                            <div class="form-group">
                                <label for="psw_set_1">{{ getTranslation('frm_lbl_new_password_1') }}</label>
                                <input
                                        type="password"
                                        id="psw_set_1"
                                        class="form-control"
                                        formControlName="psw_set_1"
                                        v-model="passwordNew">
                            </div>
                            <div class="form-group">
                                <label for="psw_set_2">{{ getTranslation('frm_lbl_new_password_2') }}</label>
                                <input
                                        type="password"
                                        id="psw_set_2"
                                        class="form-control"
                                        formControlName="psw_set_2"
                                        v-model="repeatPasswordNew">
                            </div>

                            <button
                                    @click.prevent="changePassword"
                                    class="btn btn-primary"
                                    type="submit"
                                    >
                                {{ getTranslation('btn_lbl_save_new_password') }}
                            </button>
                        </form>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';
    import {validationMixin} from '../../../../Banet/mixins/validationMixin';
    import Switch from "../../../public/components/Switch.vue";
    import BanetUpload from '../upload/Upload.vue';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';
    import CallSettings from "../../../protected/components/settings/call_settings.vue";
    // import bcrypt from 'bcryptjs';

    export default {
        mixins: [ translationMixin, dropdownMixin, clickaway, validationMixin ],
        created: function(){
           this.client.user = {};
            const id = this.$route.params.id;
            this.$socket.emit('getClient', id);
        },
        props: [ 'hideTitle' ],
        sockets:{
           userUpdated: function(user){
              this.client.user = user;
           },
            clientData: function(client){
                if(!client || typeof client === "undefined") { return; }
                this.client = client;
                this.username = this.client.username;
                this.clientPrevValues = JSON.parse(JSON.stringify(this.client));
                this.setClientLanguage(this.client.language);
                this.audioDisplay = true;
                this.hotlineNumber = this.client.hotlineNumber;
                this.useCustomers = this.client.useCustomers;
            },
//            clientChanged: function(){
////                this.$router.push('/clients');
//               this.$socket.emit('getClient', this.client._id);
//            },

           clientChanged: function(client) {

              var that = this;
              this.client = client;
              this.hotlineNumber = this.client.hotlineNumber;
              this.clientPrevValues = client;   // added for sound not deleted error
              this.clientTempValues = JSON.parse(JSON.stringify(this.client));
              if(this.$refs.banetUpload){
                  this.$refs.banetUpload.removeFiles();
              }
              var fileLen = this.audioFiles.length;
              for(var i=0; i<fileLen; i++) {
                 var prop = this.audioFiles[i];
                 if(this.client[prop]) {
                    (function (j) {
                       setTimeout(function(){
                          var key = 'audioPreview' + j;
                          var audio = that.$refs['audioPreview' + j];
                          if(audio) {
                             audio.src = audio.src + '?t=' + new Date().getTime();
                             audio.load();
                          }
                       }, 500);
                    })(i);
                 }
              }

              this.showUploadForm = false;
              setTimeout(() => { this.showUploadForm = true;
                  if(!client.isDeleted){
                      this.$router.push('/');
                  }}, 0);
               mainEventBus.$emit( 'alert', { type:'success', msg:'msg_client_updated' } );

           },
           sameClientExist: function(clientData) {
              this.client.hotlineNumber = this.hotlineNumber;
               let client = clientData.client;
               let user = clientData.user;

                if (client) {
                   if(client.clientName === this.client.clientName){
                      mainEventBus.$emit( 'alert', { type:'warning', msg:'error_client_name_exists' } );
                      return;
                   }
                   if(client.username === this.client.username){
                      mainEventBus.$emit( 'alert', { type:'warning', msg:'error_username_exists' } );
                      return;
                   }
                   if(this.client.hotlineNumber && client.hotlineNumber === this.client.hotlineNumber){
                       mainEventBus.$emit( 'alert', { type:'warning', msg:'error_hotline_exists' } );
                      return;
                   }
                }
                if (user){
                   if(user.username === this.client.username){
                      mainEventBus.$emit( 'alert', { type:'error', msg:'error_username_exists' } );
                      return;
                   }
                   if(user.email === this.client.user.email){
                      mainEventBus.$emit( 'alert', { type:'error', msg:'warning_lbl_email_used' } );
                      return;
                   }
                }

               this.saveFiles();
               // deleting before files sent
               this.$refs.banetUpload.removeFiles();
               this.$socket.emit('clientUpdate', this.client);

            },
            clientByUsername: function(client) {
                if (client != null && client.username != this.username)
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_username_exists' } );
                else
                    this.saveFiles();
                    // deleting before files sent
                    this.$refs.banetUpload.removeFiles();
                    this.$socket.emit('clientUpdate', this.client);
            },
            clientPasswordChanged: function(data) {
//                this.$router.push('/clients');
//               this.$socket.emit('getClient', this.client._id);
                mainEventBus.$emit( 'alert', { type:'info', msg:'lbl_password_changed' } );
            },
            clientChangedPasswordErr: function(data) {
                mainEventBus.$emit( 'alert', { type:'warning', msg:'error_password_error' } );
            },
            soundsUpdated: function(){
                mainEventBus.$emit( 'alert', { type:'success', msg: 'msg_client_updated' } );
            }
        },
        data: function () {
            return {
                audioDisplay: false,
                clientFiles: [],
                client: {},
                clientPrevValues: [],
                labelLangString: 'English',
                username: '',
                password: '',
                passwordNew: '',
                repeatPasswordNew: '',
                required: [
                    { name: 'clientName', found: false },
                    { name: 'firstName', found: false },
                    { name: 'username', found: false },
                    { name: 'email', found: false }
                ],
                useCustomers: false,
                pathToSound: '/public/sounds/',
                showConfirmDelete: false,
                selectedFileType: '',
                audioStatus: [ false, false, false, false, false, false, false ],
                audioPlayingIndex: '',
                audioFiles: ['onDutyFile','offDutyFile','disturbFile','helpFile','acceptedFile','deniedFile','invalidFile'],
                tempFiles: [],
                showUploadForm: true,
                hotlineNumber: ''
            }
        },
        computed: {
            rootPath: function(){
                return mainEventBus.$data.serverURL;
            },
            filePath: function(){
                var path = '';
                if(this.client.clientApiToken){
                    path = this.rootPath + '/api/twilio/' + this.client.clientApiToken + '/';
                }
                return path;
            },
            fileLinkVar: function(){
                let linkVar = '?t=' + new Date().getTime();
                return linkVar;
            }
        },
        methods: {
            save: function(){
               this.client.hotlineNumber = this.hotlineNumber;
               this.client.user.username = this.client.username;
               this.client.useCustomers = this.useCustomers;
                for (let i in this.client) {
                    for (let j in this.required) {
                        if (i == this.required[j].name) {
                           this.client[i] = this.client[i].trim();
                            if (this.client[i] != '')
                                this.required[j].found = true;
                            else
                                this.required[j].found = false;
                        }
                    }
                }
                for (let i in this.client.user) {
                    for (let j in this.required) {
                        if (i == this.required[j].name) {
                           this.client.user[i] = this.client.user[i].trim();
                            if (this.client.user[i] != '')
                                this.required[j].found = true;
                            else
                                this.required[j].found = false;
                        }
                    }
                }

                for (var i in this.required) {
                    if (this.required[i].found == false) {
                        mainEventBus.$emit( 'alert', { type:'warning', msg:'error_' + this.required[i].name + '_required' } );
                       for (let i in this.required) {
                          this.required[i].found = false;
                       }
                        return false;
                    }
                }

                if (this.client.hotlineNumber && this.client.hotlineNumber != '' && !this.checkHotlineNumber()) {
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_wrong_hotline_number_format' } );
                    return false;
                }

                if (this.tempFiles.find(file => file.fileField === '')) {
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_select_file_type' } );
                    return false;
                }

                //this.audioDisplay = false;
                this.$socket.emit('getSameClientExist', this.client._id, this.client.clientName,
                   this.client.username, this.client.user._id, this.client.user.email,this.client.hotlineNumber);
            },
            changePassword: function() {
                if (this.passwordNew != '') {
                    if (this.passwordNew == this.repeatPasswordNew) {
                        var client = {
                            _id: this.client._id,
                            user: this.client.user[0],
                            password: this.passwordNew
                        };

                        this.$socket.emit('clientChangePassword', client);
                    }
                    else {
                        mainEventBus.$emit('alert', {type: 'warning', msg: 'error_passwords_no_match'});
                        return false;
                    }
                }
                else {
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_password_required' } );
                }
            },
            saveFiles: function() {
                var files = this.clientFiles;

                for (var i = 0; i < files.length; i++) {
                    if (files[i].fileObject.file) {
                        this.client[files[i].value] = files[i].fileObject.name;

                        if (!this.client.files)
                            this.client.files = {};

                        this.client.files[files[i].value] = files[i].fileObject.file;
                    }
                    else {
                        if (this.clientPrevValues.hasOwnProperty(files[i].value))
                            this.client[files[i].value] = this.clientPrevValues[files[i].value];
                        else
                            delete this.client[files[i].value];

                        if (this.client.files) {
                            delete this.client.files[files[i].value];

                            if (Object.keys(this.client.files) == 0)
                                delete this.client.files;
                        }
                    }
                }
            },
            setFiles: function(files) {
               this.clientFiles = files;
            },
            showConfirmDialog: function(fileType) {
                this.selectedFileType = fileType;
                this.showConfirmDelete = true;
            },
            confirmDelete: function(shouldDelete) {
                if (shouldDelete)
                    this.deleteFile(this.selectedFileType);

                this.selectedFileType = '';
                this.showConfirmDelete = false;
            },
            deleteFile: function(fileType) {
                var clientData = { _id: this.client._id };
                clientData[fileType] = this.client[fileType];

                this.$socket.emit('clientDeleteFile', clientData);
            },
            setClientLanguage: function(lang){
                this.client.language = lang;
                if(lang == 'en'){
                    this.labelLangString =  this.getTranslation('lbl_english');
                } else if (lang == 'de') {
                    this.labelLangString =  this.getTranslation('lbl_deutsch');
                }
            },
            goBack: function(){
                this.$router.push('/clients');
            },
            checkHotlineNumber: function() {
                var regEx = /^[+-]?\d+$/;
                return regEx.test(this.client.hotlineNumber);
            },
            playRecord: function(index){
                var refKeys = Object.keys(this.$refs);
                var numIndex = parseInt(index.split('audioPreview')[1]);

                for (var i = 0; i < refKeys.length; i++) {
                    if (refKeys[i].indexOf('audioPreview') >= 0) {
                        if (refKeys[i] != index || this.isPlaying(index))
                            this.stopRecord(refKeys[i]);
                        else {
                           this.$refs[index].load();
                           this.$refs[index].play();
                           this.audioStatus[numIndex] = true;
                        }
                    }
                }

                if (this.audioStatus[numIndex])
                    this.audioPlayingIndex = index;
            },
            stopRecord: function(index) {
                if (this.$refs[index]) {
                    this.$refs[index].pause();
                    this.$refs[index].currentTime = 0;
                }

                this.audioStatus[parseInt(index.split('audioPreview')[1])] = false;
                this.audioPlayingIndex = '';
            },
            isPlaying: function(index) {
                return this.$refs[index] && !this.$refs[index].paused &&
                    this.$refs[index].currentTime > 0 && !this.$refs[index].ended;
            },
            audioPreviewClass: function(index) {
                if (this.audioPlayingIndex != index)
                    return 'fa-play';
                else
                    return 'fa-stop';
            },
            playStopTooltip: function(index) {
                if(this.audioPlayingIndex != index)
                    return 'lbl_play';
                else
                    return 'lbl_stop';
            },
           loadAudio(){
              this.audioDisplay = true;
           },
            setTempFiles(tempFiles) {
               this.tempFiles = tempFiles;
            },
           validatePhoneNum(event){
              if(event.key === 'Delete'){
                  this.client.hotlineNumber = this.hotlineNumber;
                  return true;
               }
              this.hotlineNumber = this.validatePhoneChar(this.hotlineNumber);
              this.client.hotlineNumber = this.hotlineNumber;
           }
        },
        components: {
            'banet-upload': BanetUpload,
            'banet-modal-confirm': BanetModalConfirm,
            'app-switch': Switch,
            callSettings: CallSettings,
        }
    }
</script>


<style scoped>
    .same-row-spaced-apart-aligned { display: flex; justify-content: space-between; align-items: center; }
    .dropdown {
        width: 100%;
    }
    .dropdown .caret {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .dropdown .dropdown-toggle {
        width: 100%;
        text-align: left;
    }

    .dropdown-menu {
        width: 100%;
        margin-top: -1px;
    }

    .form-group {
        word-break: break-word;
    }

    input.form-control[type="file"] {
        height: auto;
    }

    label {
        display: block;
    }

    .el-icon-close {
        opacity: .75;
        transform: scale(.8);
        cursor: pointer;
        margin-left: 10px;
        color: #13ce66;
    }

    .el-icon-close:hover {
        color: #48576a;
    }
</style>


// WEBPACK FOOTER //
// ClientEdit.vue?301291f2